import React from 'react';
import { siteConfig } from '../data/config';
import AppCard from '../components/AppCard';

const Home = () => {
  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">{siteConfig.hero.title}</h1>
            <p className="hero-subtitle">{siteConfig.hero.subtitle}</p>
            <p className="hero-description">{siteConfig.hero.description}</p>
            <div className="hero-buttons">
              <a href="#apps" className="btn btn-primary">View My Apps</a>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-placeholder">
              <i className="fas fa-code"></i>
            </div>
          </div>
        </div>
      </section>

      <section id="apps" className="apps-section">
        <div className="container">
          <h2 className="section-title">My Applications</h2>
          <p className="section-subtitle">Here are some of the apps I've built</p>
          
          <div className="apps-grid">
            {siteConfig.apps.map((app) => (
              <AppCard key={app.id} app={app} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
